'use client'

import { useEffect } from 'react'

export default function ThemeInit() {
  useEffect(() => {
    try {
      const stored = localStorage.getItem('theme')
      if (stored === 'dark' || stored === 'light') {
        document.documentElement.classList.toggle('dark', stored === 'dark')
        return
      }
    } catch {}
    const prefers = typeof window !== 'undefined' && window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)').matches : false
    document.documentElement.classList.toggle('dark', prefers)
  }, [])
  return null
}

